import { computed, observable } from 'mobx';
import Abstract from './abstract';

const KEY_MAP = { uuid: 'value', value: 'label' };

export class Preparation extends Abstract {
  @observable toolbar = { ids: [] };
  @observable coursewares = [];
  @observable filters = {};
  @observable searchResults = [];
  @observable searchBusy = false;
  @observable zipUrl = null;
  @observable zipHasResources = null;

  @computed get hasSap() {
    const hasLabels = nx.get(this.filters, 'labels.length');
    const hasTypes = nx.get(this.filters, 'types.length');
    return Boolean(hasLabels || hasTypes);
  }

  @computed get current() {
    const tree = new nx.Tree(this.coursewares);
    const { id } = nx.$root.params;
    return tree.find((_, item) => item.value === parseInt(id));
  }

  @computed get usable() {
    return nx.get(this.current, 'usable');
  }

  @computed get coursewareId() {
    const { id } = nx.$root.params;
    return id;
  }

  @computed get hasSelected() {
    return this.toolbar.ids.length > 0;
  }

  getStdFilters(inKey) {
    return nx.keyMap(nx.get(this.filters, inKey, []), KEY_MAP);
  }

  reset() {
    this.filters = {};
    this.zipUrl = null;
    this.searchResults = [];
    this.searchBusy = false;
  }
}
